/**
 * Custom error type for API errors
 */
export class TmApiError extends Error {
    config: any;
    data: any;
    status: number;
    statusText: string;
}
